// extracted by mini-css-extract-plugin
export var animationAbsolute = "_3g-q";
export var animationRelative = "_3g-p";
export var backdropBlur = "_3g-0";
export var detailLabelCell = "_3g-12";
export var detailTable = "_3g-11";
export var detailValueCell = "_3g-13";
export var docIconBox = "_3g-1d";
export var docIconBoxMd = "_3g-1f";
export var docIconBoxSm = "_3g-1e";
export var docTypeRow = "_3g-16";
export var docTypeRowInner = "_3g-17";
export var dropdownMatchDatePicker = "_3g-3";
export var evidenceCardContent = "_3g-1c";
export var fileUploadSpin = "_3g-j";
export var gorgiasOpenButton = "_3g-15 _3g-d";
export var gorgiasTicketCard = "_3g-14";
export var heroModalFooterButton = "_3g-18";
export var hiddenContainer = "_3g-o";
export var iconPrimary = "_3g-1g";
export var iconQuaternary = "_3g-1i";
export var iconTertiary = "_3g-1h";
export var integrationCard = "_3g-1";
export var integrationLogoBox = "_3g-2";
export var mainColumnSticky = "_3g-1b";
export var maxWidthContainer = "_3g-19";
export var modalContentBody = "_3g-a";
export var modalHeaderImage = "_3g-5";
export var modalImageLabel = "_3g-7";
export var modalImageOverlay = "_3g-6";
export var modalImageSubtitle = "_3g-9";
export var modalImageTitle = "_3g-8";
export var modalImageWrapper = "_3g-4";
export var modalStickyFooter = "_3g-b";
export var removeButton = "_3g-e";
export var sidebarColumn = "_3g-1a";
export var spinner = "_3g-i";
export var timelineLine = "_3g-y";
export var timelineLineBlack = "_3g-10 _3g-y";
export var timelineLineGray = "_3g-z _3g-y";
export var timelineLineHeight = "_3g-x";
export var tlDotActivate = "_3g-u";
export var tlDotActivateAnim = "_3g-t";
export var tlDotHide = "_3g-s";
export var tlDotHideAnim = "_3g-r";
export var tlLineActivate = "_3g-w";
export var tlLineActivateAnim = "_3g-v";
export var uploadHint = "_3g-n";
export var uploadIconBox = "_3g-k";
export var uploadLabel = "_3g-m";
export var uploadText = "_3g-l";
export var uploadZone = "_3g-f";
export var uploadZoneCursorDefault = "_3g-h";
export var uploadZoneCursorPointer = "_3g-g";
export var uploadedFileRow = "_3g-c";
export var viewButton = "_3g-d";